export interface AppNotification {
  id: string;
  type: "info" | "warning";
  title: string;
  description: string;
  href: string;
}

export function useNotifications() {
  const notifications: AppNotification[] = [];

  return { data: notifications };
}
